<template>
  <page-edicion>
    <page-header title="Crear descuento" back-to="/descuentos" />
    <formulario :descuento="descuento" @submit="insertar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import * as tipoDescuentoApi from "@/services/tipoDescuento.js";

export default {
  components: { Formulario },
  data() {
    return {
      descuento: tipoDescuentoApi.crear(),
    };
  },
  methods: {
    insertar() {
      var descuento = {
        descuento: this.descuento,
      };
      tipoDescuentoApi.insertar(descuento).then(() => {
        this.$router.push({ path: "/descuentos" });
      });
    },
  },
};
</script>
